<template>
  <div class="receiver">
    <h2 class="receiver__title">{{ $t(`${namespace}.title`) }}</h2>
    <div class="receiver__line">
      <div v-if="data && data.receiverName" class="receiver__item">
        <div class="receiver__item__label">{{ $t(`${namespace}.receiverName`) }}</div>
        <div class="receiver__item__value text--ellipsis">{{ data.receiverName }}</div>
      </div>

      <div v-if="data && data.receiverPhone" class="receiver__item">
        <div class="receiver__item__label">{{ $t(`${namespace}.receiverPhone`) }}</div>
        <div class="receiver__item__value text--ellipsis">{{ data.receiverPhone }}</div>
      </div>

      <div v-if="data && data.receiverCode">
        <div class="receiver__item__label">{{ $t(`${namespace}.receiverCode`) }}</div>
        <div class="receiver__item__value text--ellipsis">{{ data.receiverCode }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'receiverInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.details.receiver'
    }
  }
}
</script>

<style lang="scss" scoped>
.receiver {
  padding: 0 0 24px;
}

.receiver__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 16px;
}

.receiver__item__label {
  color: $gray-6;
  font-size: 12px;
}

.receiver__item__value {
  margin-bottom: 8px;
}
</style>
